import { Component,OnInit } from '@angular/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from './shared/format-datepicker';

import { HostListener } from '@angular/core';
import {UtilitiesService} from '././Services/utilities.service';
import { Router ,NavigationStart, ActivatedRoute} from '@angular/router';
import { Subject } from 'rxjs';
import { config } from '../assets/config.js';



@Component({
  
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class AppComponent implements OnInit {
  title = 'SaibaNewGen';
  
  userActivity;
  userInactive: Subject<any> = new Subject();
  constructor(private router: Router,private service:UtilitiesService, private route: ActivatedRoute) {

 var ss= location.origin;

 

   // this.userInactive.subscribe(() => console.log('user has been inactive for 3s'));
   
if(this.service.Url=='')
{

   this.service.getApiUrlJSON().subscribe(data => {

    const domain=location.origin;
   
var jsdata=data;

var fildata= jsdata.filter(item=>item.Url==domain);
this.service.Url=fildata[0].ApiUrl;


    
});
}
//this.setTimeout();

  }

//   @HostListener('click', ['$event.target']) 
//  onClick() {
//    if (JSON.parse(localStorage.getItem("isLoggedIn"))) {
//      let storage = JSON.parse(localStorage.getItem("token"));
//      let reqObj: any = {}
//      if (storage) {
//        reqObj.token = storage.token;
//        reqObj.UserName = storage.User.UserName;
//        reqObj.CompanyId = storage.User.CompanyId;
//        reqObj.EmpCode = storage.Employee.EmpCode;
//        reqObj.Email = storage.Employee.Email;
//      }
//      this.service.PostRequest(this.service.Url + "login/CheckToken", reqObj).subscribe(resp => {
//        if (!resp) {
//          localStorage.removeItem("localid");
//          localStorage.removeItem("token");
//          localStorage.removeItem("moduleid");
//          localStorage.removeItem("isLoggedIn");
//          this.router.navigate(['/home']);
//          this.service.isLoggedIn = false;
//        }
//      });
//    }
//  }


  setTimeout() {
    this.userActivity = setTimeout(() => {
      if (this.service.isLoggedIn) {
        this.userInactive.next(undefined);
        console.log('logged out');
        localStorage.removeItem("localid");
        localStorage.removeItem("token");
        localStorage.removeItem("moduleid");
        localStorage.removeItem("isLoggedIn");
        this.service.isLoggedIn=false;
        this.router.navigate(['/home']);
      }
    }, 100 * 60 * 1000);
  }
  @HostListener('window:mousemove') refreshUserState() {
  
   // clearTimeout(this.userActivity);
   // this.setTimeout();
    
  }



  ngOnInit(): void {
   
if(localStorage.getItem("token"))
    {
      if (this.service.IstokenExpired()) {
        localStorage.clear();
        this.router.navigate(['/home']);
      } else {
      
      }
    }
  }

  
  
}
